<template>
  <div class="organization-pdls mt-5" v-if="organization">

    <v-row>
      <v-col class="text-right">
        <v-btn small color="primary" v-if="canWrite" @click="createDialog = true">
          <v-icon small left>mdi-plus</v-icon>
          {{ $t('pdl.create') }}
        </v-btn>
        <audit-trail-button class="ml-2" entity-type="Pdl" :organization-id="$route.params.id" />
      </v-col>
    </v-row>

    <v-row no-gutters class="mt-5">
      <v-col>
        <v-data-table
            :headers="headers"
            :items="items"
            :loading="loading"
            hide-default-footer
            disable-pagination
            @click:row="row => $router.push({name: 'pdl.detail', params: {id: row.id}})"
        >
          <template #item.name="{item}">
            <router-link :to="{name: 'pdl.detail', params: {id: item.id}}">
              {{ item.name }}
            </router-link>
            <v-chip v-if="item.isDefault" x-small class="ml-2">{{ $t('pdl.default') }}</v-chip>
          </template>

          <template #item.reference="{value}">
            <template v-if="value">{{ value }}</template>
            <template v-else><span class="text--secondary">{{ $t('pdl.reference-missing') }}</span></template>
          </template>

          <template #item.createdAt="{value}">
            {{ value|formatDate($t('format_date')) }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="createDialog" max-width="600">
      <v-form @submit.prevent="create">
        <v-card>
          <v-card-title>{{ $t('pdl.create') }}</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-col>
                <v-text-field
                    :label="$t('name')"
                    v-model="createForm.name"
                    hide-details
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                    :label="$t('pdl.reference')"
                    v-model="createForm.reference"
                    :hint="$t('pdl.reference-hint')"
                    persistent-hint
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-row class="ma-0">
              <v-col class="text-right">
                <v-btn class="mr-3" small @click="createDialog = false">{{ $t('cancel') }}</v-btn>
                <v-btn small color="primary" type="submit" :disabled="!createForm.name || loadingCreate" :loading="loadingCreate">
                  {{ $t('create') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

  </div>
</template>

<script>
import AuditTrailButton from "@elements/AuditTrailButton.vue";
import PdlRepository from "@repository/PdlRepository";

export default {
  components: {AuditTrailButton},

  data() {
    return {
      items: [],
      loading: false,
      createDialog: false,
      createForm: {name: null, reference: null},
      loadingCreate: false,
    }
  },

  watch: {
    'organization.id'() {
      this.loadData()
    },

    createDialog(val) {
      if (val) {
        this.createForm = {name: null, reference: null}
      }
    },
  },

  mounted() {
    this.loadData()
  },

  computed: {
    organization() {
      return this.$parent.organization ?? null
    },

    canWrite() {
      return this.currentUser.isZE && this.currentUser.permissions.includes('STATION_WRITE')
    },

    headers() {
      return [
        { text: this.$t('name'), value: 'name' },
        { text: this.$t('pdl.reference'), value: 'reference' },
        { text: this.$t('created-at'), value: 'createdAt' },
      ]
    },
  },

  methods: {
    loadData() {
      if (!this.organization?.id) return
      this.loading = true
      PdlRepository.search({organizationId: this.organization.id}).then(items => {
        this.items = items
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.notifyError(e)
      })
    },

    create() {
      this.loadingCreate = true
      PdlRepository.create({
        organizationId: this.organization.id,
        name: this.createForm.name,
        reference: this.createForm.reference,
      }).then(result => {
        this.loadingCreate = false
        this.createDialog = false
        this.$router.push({name: 'pdl.detail', params: {id: result.id}})
      }).catch(e => {
        this.loadingCreate = false
        this.notifyError(e)
      })
    },
  }
}
</script>
